
export const baseurl='https://api.themoviedb.org/3';
export const apikey="d03799692be1c26faf0ade18a4205f9f";
export const imageurl = 'https://image.tmdb.org/t/p/original';
export const originalurl=`https://api.themoviedb.org/3/discover/tv?api_key=${apikey}&with_networks=213`;
export const trendingurl=`https://api.themoviedb.org/3/trending/all/week?api_key=${apikey}&language=ml-IN`;
export const actionurl=`https://api.themoviedb.org/3/discover/movie?api_key=${apikey}&with_genres=28`;
export const romanceurl=`https://api.themoviedb.org/3/discover/movie?api_key=${apikey}&with_genres=10749`;
export const comedyurl=`https://api.themoviedb.org/3/discover/movie?api_key=${apikey}&with_genres=35`;
export const horrorurl=`https://api.themoviedb.org/3/discover/movie?api_key=${apikey}&with_genres=27`;
export const documentaryurl=`https://api.themoviedb.org/3/discover/movie?api_key=${apikey}&with_genres=99`;